export enum ServiceChargeConfigurationType {
  PERCENTAGE = 'percentage',
  FIXED = 'fixed',
  OPEN = 'open',
}

export interface ServiceChargeConfigurationExtendedConfig {
  isChargeToOwner: boolean;
  isNonRevenue: boolean;
  isMinimumThresholdAmount: boolean;
  isServiceChargeAfterTax: boolean;
  isAutoApply: boolean;
  isApplyOnDineIn: boolean;
  isApplyOnTakeAway: boolean;
  isApplyOnDelivery: boolean;
  isApplyBeforeTax: boolean; // if this field is false it will be consider as apply after tax
  isServiceChargeTaxed: boolean;
  minPartySize: number;
}
